import axios from "axios";
import router from "@/router";
import { Message } from "element-ui";

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  (config) => {
    let accessToken = sessionStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.accessToken = encodeURIComponent(accessToken);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  async (response) => {
    if (response.data.code == 200) {
      return response.data.data;
    } else if (response.data.code == 401 || response.data.code == 400) {
      console.log("token expired, try to refresh");
      let refreshToken = sessionStorage.getItem("refreshToken");
      if (!refreshToken) {
        if (!sessionStorage.getItem("loginByEmail")) {
          router.replace("/login");
        }
      }
      // 发送请求, 进行刷新token操作, 获取新的token
      const data = await http({
        method: "put",
        url: "/refreshToken",
        headers: {
          refreshToken: refreshToken,
        },
      });
      // 保存token
      sessionStorage.setItem("accessToken", data.accessToken);
      sessionStorage.setItem("refreshToken", data.refreshToken);
      // 这里需要把headers清掉，否则请求时会报错，原因暂不详...
      response.config.headers = undefined;
      // 重新发送刚才的请求
      return http(response.config);
    } else {
      if (
        response.config.url.indexOf("contact/customer/service") >= 0 ||
        response.config.url.indexOf("find/customer/service") >= 0
      ) {
        window.parent.postMessage({ type: "noServe" }, "*");
      } else {
        Message({
          message: response.data.message,
          type: "error",
          duration: 1500,
          customClass: "element-error-message-zindex",
        });
      }
      return Promise.reject(response.data);
    }
  },
  (error) => {
    switch (error.response.status) {
      case 400:
        Message({
          message: error.response.data,
          type: "error",
          duration: 1500,
          customClass: "element-error-message-zindex",
        });
        break;
      case 401:
        if (!sessionStorage.getItem("loginByEmail")) {
          router.replace("/login");
        }

        break;
      case 405:
        Message({
          message: "http request method is incorrect",
          type: "error",
          duration: 1500,
          customClass: "element-error-message-zindex",
        });
        break;
      case 404:
      case 500:
        Message({
          message: "Server error, please try again later",
          type: "error",
          duration: 1500,
          customClass: "element-error-message-zindex",
        });
        break;
      case 501:
        Message({
          message:
            "Server does not support the function required by the current request",
          type: "error",
          duration: 1500,
          customClass: "element-error-message-zindex",
        });
        break;
    }

    return Promise.reject(error);
  },
);

export default http;
